export default {
  tipo: 'PF',
  emails: [],
  telefones: [],
  cpfCnpj: null,
  nomeRazaoSocial: null,
  funcao: '',
  enderecoCorrespondencia: {
    bairro: null,
    cep: null,
    complemento: null,
    logradouro: null,
    municipio: {
      id: null,
      nome: null,
      codigoEstado: null
    },
    numero: null,
    semNumero: false,
    uf: null,
    referencia: null,
    comunidadeLocalidade: null
  },
  pessoaFisica: {
    id: null,
    nome: null,
    cpf: null,
    rg: null,
    sexo: null,
    nacionalidade: null,
    dataNascimento: null,
    regimeBens: null,
    naturalidade: {
      id: null,
      nome: null,
      codigoEstado: null
    },
    ufNaturalidade: null,
    estadoCivil: null,
    possuiCertidaoObito: null,
    telefones: [],
    email: [],
    rendaFamiliar: null
  },
  pessoaJuridica: {
    cnpj: null,
    razaoSocial: null,
    telefones: [],
    email: null
  }
}



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/emptyPessoa.js